import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["content", "trigger"]
  static classes = ["hidden"]

  connect() {
    this.syncExpandedState()
  }

  toggle() {
    if (!this.hasContentTarget) return

    this.contentTarget.classList.toggle(this.hiddenClassName)
    this.syncExpandedState()
  }

  syncExpandedState() {
    if (!this.hasContentTarget) return

    const expanded = !this.contentTarget.classList.contains(this.hiddenClassName)
    this.triggerTargets.forEach((trigger) => {
      trigger.setAttribute("aria-expanded", expanded)
    })
  }

  get hiddenClassName() {
    return this.hasHiddenClass ? this.hiddenClass : "max-md:hidden"
  }
}
